import React, { Component } from  'react';
import AnimContainer from './AnimContainer';
import { castVL2VG } from 'gemini/gemini.web';
import './css/VisCol.css'
import { Col, Button } from 'react-bootstrap'



class VisCol extends Component {

  render() {

    let sSpec = this.props.sequence[this.props.currAnimId],
      eSpec = this.props.sequence[this.props.currAnimId+1],
      gemSpec = this.props.animationSpecs[this.props.currAnimId];
    let hasSelectedAnim = true;
    if (this.props.currAnimId===undefined) {
      sSpec = this.props.sequence[0]
      hasSelectedAnim = false;
    }
    try {
      sSpec = castVL2VG(sSpec);
    } catch (e) {
      console.log("WARNING: the given VL spec is invalid to be compiled.")
      sSpec = {}
    }
    try {
      eSpec = castVL2VG(eSpec);
    } catch (e) {
      console.log("WARNING: the given VL spec is invalid to be compiled.")
      eSpec = {}
    }

    return <Col xs={5} id="vis-col" className="p-0">


        <div className="text-center mt-3 mb-2">
          <span className="d-inline-block">Animation</span>
          <Button
            id="animViewBtn"
            size="sm"
            variant="light"
            className="ml-1"
            onClick={this.props.showAnimViewModal.bind(this)}
          >
            <span role="img" aria-label="See with a large screen">🔍</span>
          </Button>

        </div>

        <div className="border" style={{height: "100%"}}>
          <AnimContainer
            sSpec={sSpec || {}}
            eSpec={eSpec || {}}
            gemSpec={gemSpec || {}}
            sequence={hasSelectedAnim ? undefined : this.props.sequence}
            animationSpecs={hasSelectedAnim ? undefined : this.props.animationSpecs}
            showMetaInfo={false}
            height={"100%"}
            showGif={true}
            id="animView"
          />
      </div>

    </Col>
  }
}

export default VisCol;
